import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { create } from 'jss'
import rtl from 'jss-rtl'
import MomentUtils from '@date-io/moment'
import { SnackbarProvider } from 'notistack'
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import GlobalStyles from 'src/components/GlobalStyles'
import ScrollReset from 'src/components/ScrollReset'
import CookiesNotification from 'src/components/CookiesNotification'
import { AuthProvider } from 'src/contexts/JWTAuthContext'
import useSettings from 'src/hooks/useSettings'
import { createTheme } from 'src/theme'
import routes, { RenderRoutes } from 'src/routes'
import ErrorBound from 'src/components/ErrorBound'
// eslint-disable-next-line no-unused-vars
import i18n from './i18'
import { useFetchEnums, EnumsContext } from './hooks/useEnums'
import './assets/css/main.scss'
import DashboardLayout from './layouts/DashboardLayout'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const history = createBrowserHistory()

const App = () => {
  const enums = useFetchEnums()
  const { settings } = useSettings()

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
  })

  return (
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <StylesProvider jss={jss}>
          <EnumsContext.Provider value={enums}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <SnackbarProvider dense maxSnack={3}>
                <ErrorBound>
                  <AuthProvider>
                    <GlobalStyles />
                    <ScrollReset />
                    <CookiesNotification />
                    <DashboardLayout>{RenderRoutes(routes)}</DashboardLayout>
                  </AuthProvider>
                </ErrorBound>
              </SnackbarProvider>
            </MuiPickersUtilsProvider>
          </EnumsContext.Provider>
        </StylesProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App
